import { createConsumer } from "@rails/actioncable"

const resolveCableUrl = (): string => {
  const meta = document.querySelector<HTMLMetaElement>("meta[name='action-cable-url']")
  const rawUrl = meta?.content ?? "/cable"

  if (rawUrl.startsWith("/")) {
    const protocol = window.location.protocol === "https:" ? "wss" : "ws"
    const hostname = window.location.hostname
    const port = window.location.port === "" ? "" : window.location.port
    const portSegment = port ? `:${port}` : ""
    return `${protocol}://${hostname}${portSegment}${rawUrl}`
  }

  if (rawUrl.startsWith("http://")) return rawUrl.replace("http://", "ws://")
  if (rawUrl.startsWith("https://")) return rawUrl.replace("https://", "wss://")

  return rawUrl
}

let cable: ReturnType<typeof createConsumer> | null = null

export const getCable = (): ReturnType<typeof createConsumer> => {
  if (!cable) {
    cable = createConsumer(resolveCableUrl())
  }
  return cable
}

export const getCableUrl = (): string => resolveCableUrl()
